export const pagePadding = "padding: 16px 16px;";
